/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserWithTokenFromJSON, UserWithTokenToJSON } from './UserWithToken';
export function ResetPasswordResponseDataFromJSON(json) {
    return ResetPasswordResponseDataFromJSONTyped(json, false);
}
export function ResetPasswordResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        user: !exists(json, 'user') ? undefined : UserWithTokenFromJSON(json['user'])
    };
}
export function ResetPasswordResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        user: UserWithTokenToJSON(value.user)
    };
}
